import React, { useEffect, useState } from "react"
import { reactLocalStorage } from "reactjs-localstorage"
import config, { getHeaders } from "../config"
import './Profile.scss'
import { useHistory } from "react-router-dom";

function Profile({handleClose,menuColor,setSideMenu}) {
    const [msisdn, setMsisdn] = useState('')
    const [status, setStatus] = useState('')
    const [displayStatus, setDisplayStatus] = useState('')
    const [msg, setMsg] = useState('')
    const [loading,setLoading]=useState(false)
    const [openModal ,setOpenModal] = useState(false)
    const [openConfirmModal ,setOpenConfirmModal] = useState(false)
    const [loader ,setLoader] = useState(false)
    const [showUnSub ,setShowUnSub] = useState('')
    
    let history = useHistory();

    useEffect(() => {
      const subStatus = reactLocalStorage.get("subStatus");
      const msisdn = reactLocalStorage.get("msisdn");
      const displayStatus = reactLocalStorage.get("status_display");
      const show_unsub = reactLocalStorage.get("showUnsub");
      setStatus(subStatus);
      setDisplayStatus(displayStatus);
      setShowUnSub(show_unsub);
      setMsisdn(msisdn);
      setLoading(false);
    }, []);
  

    // function handleBtnClick() {
    //     setLoader(true);
    //     const url = `${config.get('base')}${config.get('unsubscribe')}`
    //     fetch(url, {
    //         method: 'POST',
    //         body: JSON.stringify({ "uid" : reactLocalStorage.get("uid") ? reactLocalStorage.get("uid") : ""}),
    //         headers: config.get('headers')
    //     })
    //         .then(res => {
    //             if (!res.ok) { throw res }
    //             return res.json()
    //         })
    //         .then((result) => {
    //             console.log('result message::', result)
    //             checksub();
    //             setMsg(result.message)
    //             setShowUnSub(result.showUnsub)
    //             setOpenModal(true)
    //             reactLocalStorage.set("show_un_sub",JSON.stringify(result.showUnsub))
    //         },
    //             (error) => {
    //                 console.log('error:::', error)
    //                 setLoader(false)
    //             })
    //     }

        function handleBtnClick() {
            setLoader(true);
            const url = `${config.get("base")}${config.get("unsubscribe")}`;
            fetch(url, {
              method: "POST",
              body: JSON.stringify({
                uid: reactLocalStorage.get("uid") ? reactLocalStorage.get("uid") : "",
              }),
              headers: getHeaders(),
            })
              .then((res) => {
                if (!res.ok) {
                  throw res;
                }
                return res.json();
            })
            .then(
              (result) => {
                console.log("result message::", result);
                checksub();
                setMsg(result.message);
                setShowUnSub(result.showUnsub);
                setOpenModal(true);
                reactLocalStorage.set(
                  "show_un_sub",
                  JSON.stringify(result.showUnsub)
                );
              },
              (error) => {
                console.log("error:::", error);
                setLoader(false);
              }
            );
        }
              
     
    // const checksub = () => {
    //     const url = `${config.get('base')}${config.get('checkSub')}`
    //     const uid =  reactLocalStorage.get("uid")?reactLocalStorage.get("uid"):"";
    //     fetch(url, {
    //         method: 'POST',
    //         body: JSON.stringify({ 'uid': uid }),
    //         headers: config.get('headers')
    //     })
    //         .then(res => {
    //             if (!res.ok) { throw res }
    //             return res.json()
    //         })
    //         .then((result) => {
    //             setLoader(false)
    //             console.log('result message::', result)
    //             reactLocalStorage.set("subStatus", result.subStatus)
    //             reactLocalStorage.set("status_display", result.status_display)
    //             reactLocalStorage.set("msisdn", result.msisdn)
    //             reactLocalStorage.set("unsub_text",result.unsub_msg_txt)
    //             reactLocalStorage.set("showUnsub",result.showUnsub)
    //         },
    //             (error) => {
    //                 setLoader(false)
    //                 console.log('error:::', error)
    //             })
    // }
    
    const checksub = () => {
        const url = `${config.get("base")}${config.get("checkSub")}`;
        const uid = reactLocalStorage.get("uid")
          ? reactLocalStorage.get("uid")
          : "";
        fetch(url, {
          method: "POST",
          body: JSON.stringify({ uid: uid }),
          headers: config.get("headers"),
        })
          .then((res) => {
            if (!res.ok) {
              throw res;
            }
            return res.json();
        })
        .then(
          (result) => {
            setLoader(false);
            console.log("result message::", result);
            reactLocalStorage.set("subStatus", result.subStatus);
            reactLocalStorage.set("status_display", result.status_display);
            reactLocalStorage.set("msisdn", result.msisdn);
            reactLocalStorage.set("unsub_text", result.unsub_msg_txt);
            reactLocalStorage.set("showUnsub", result.showUnsub);
          },
          (error) => {
            setLoader(false);
            console.log("error:::", error);
          }
        );
    };
      

    function capitalizeFirstLetter(string) {
        if (string.toLowerCase() === "failed") {
          string = "inactive";
        }
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
    
      
     console.log("Status display ::",displayStatus)
    return (
//         <React.Fragment>
//                 <div className="profile m-w p-4 ">
//                 <div className="flex font">
//                     {status &&
//                         <>
//                             <h2>Status</h2>
//                             <h3>{capitalizeFirstLetter(displayStatus)}</h3>
//                         </>
// }
//                 </div>
//                 <div className="flex font">
//                     {msisdn && msisdn!==undefined && msisdn!=='' && msisdn!=='undefined' &&
//                         <>
//                             <h2>Msisdn</h2>
//                             <h3>{reactLocalStorage.get("msisdn")}</h3>
//                         </>}
//                 </div>
//                 <div className="center">
//                     {loader ?<Loader/>:
//                     <div>
//                         {status && status.toLowerCase()=='active'   &&
        
//                     <button className="unsubBtn" onClick={()=>{setOpenConfirmModal(true)}}>{unsub_ok_txt}</button>
//                 }
//                     {openConfirmModal && <ConfirmPopup show={openConfirmModal} menuColor={menu_color} cancel={unsub_cancel_txt} closeModal={()=>setOpenConfirmModal(false)} handleSubmit={
//                         ()=>
//                         {
//                             setOpenConfirmModal(false)
//                             handleBtnClick()
//                         }
//                     }>
//                         <div>{unsub_msg_txt}</div>
//                     </ConfirmPopup>}
//                     {openModal && <Modal show={openModal} menuColor={menu_color} closeModal={() => {setOpenModal(false);
//                      handleClose()
//                     }}>
//                         <div>{msg}</div>
//                     </Modal>}
//                 </div>
//                  }
//             </div>
//             </div>
//         </React.Fragment>
<>
{loading ? (
        <div className="ld-bg">
          <div className="lds"></div>
        </div>
      ) : (
        <div className="container m-w">
          <div className="columns is-mobile">
            <div className="column is-full">
              <div className="card">
                <div className="card-content ">
                  <div className="display text-black">
                    <div className="text-start">
                      <h3 className="bold text-lg">Subscription Status</h3>
                      {displayStatus ? (
                        <h2 className="mt-4 semibold">
                          {capitalizeFirstLetter(displayStatus)}
                        </h2>
                      ) : (
                        <h2 className="mt-4">--</h2>
                      )}
                    </div>
                    <div className="text-start">
                      <h3 className="bold text-lg">Msisdn</h3>
                      {reactLocalStorage.get("msisdn") ? (
                        <h2 className="mt-4 semibold">
                          {reactLocalStorage.get("msisdn")}
                        </h2>
                      ) : (
                        <h2 className="mt-4">--</h2>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

</>
    )
                    }

export default Profile